<template>
  <div class="regist">
    <div class="re_header">
      <ul>
        <li class="active"><i class="el-icon-circle-check left-row"></i>填写注册信息<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>邮箱验证<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>注册成功</li>
      </ul>
    </div>
    <el-form :model="userItem" ref="ruleForm" :rules="userRule" label-width="100px" class="userForm">
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="userItem.nickname" placeholder="请输入昵称"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="account">
        <el-input v-model="userItem.account" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="userItem.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="password2">
        <el-input type="password" v-model="userItem.password2" placeholder="请输入确认密码"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input type="email" v-model="userItem.email" placeholder="请输入邮箱,找回密码用"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="vcode">
        <el-input v-model="userItem.vcode" placeholder="请输入验证码" class="vcode" ref="vcode"></el-input>
        <img class="img-code" id="vcode" :src="this.$root.URL + '/ValidateImage.do'" alt="点击刷新验证码" title="点击刷新验证码"
          @click="reloadImg">
        <a class="checkcode" @click="reloadImg" href="#">看不清?换一张</a>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox label="我同意注册协议" name="type" v-model="checked"></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="btn-reg" :loading="registing" @click="submitForm()">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'regist',
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.userItem.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validateVcode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        let queryParam = { vCode: value }
        this.sapost('/dmc/account/unique', queryParam, r => {
          let result = r.data
          if (result.retCode === '1') {
            callback(new Error('验证码输入有误'))
          } else {
            callback()
          }
        })
      }
    }
    var nicknameUnique = (rule, value, callback) => {
      if (value !== '') {
        let queryParam = { nickname: value }
        this.sapost('/dmc/account/unique', queryParam, r => {
          let { retCode, retMsg } = r.data
          if (retCode === '1') {
            callback(new Error(retMsg))
          } else {
            callback()
          }
        })
      } else {
        callback()
      }
    }
    var accountUnique = (rule, value, callback) => {
      if (value !== '') {
        let queryParam = { account: value }
        this.sapost('/dmc/account/unique', queryParam, r => {
          let { retCode, retMsg } = r.data
          if (retCode === '1') {
            callback(new Error(retMsg))
          } else {
            callback()
          }
        })
      } else {
        callback()
      }
    }
    var emailUnique = (rule, value, callback) => {
      if (value !== '') {
        let queryParam = { email: value }
        this.sapost('/dmc/account/unique', queryParam, r => {
          let { retCode, retMsg } = r.data
          if (retCode === '1') {
            callback(new Error(retMsg))
          } else {
            callback()
          }
        })
      } else {
        callback()
      }
    }
    return {
      checked: true,
      registing: false,
      userItem: {
        nickname: '',
        account: '',
        password: '',
        password2: '',
        email: '',
        vcode: ''
      },
      userRule: {
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { pattern: /^[\u0391-\uFFE5]+$/, message: '请输入中文' },
          { validator: nicknameUnique }
        ],
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { pattern: /^\w{3,12}$/, message: '请输入3-12位数字、字母、下划线' },
          { validator: accountUnique }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/, message: '必须包含数字、大小写字母，且至少六位' }
          // { validator: validaePass2 }
        ],
        password2: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { pattern: /^(?:[a-z0-9]+[_\-+.]?)*[a-z0-9]+@(?:([a-z0-9]+-?)*[a-z0-9]+\.)+([a-z]{2,})+$/i, message: '邮箱格式不正确' },
          { validator: emailUnique }
        ],
        vcode: [
          { required: true, validator: validateVcode, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    reloadImg () {
      document.getElementById('vcode').src = this.$root.URL + '/ValidateImage.do?' + 'radom=' + Math.random()
      this.$refs.vcode.focus()
    },
    submitForm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.registing = true
          this.sapost('/dmc/account/register', this.userItem, r => {
            let { retMsg, retCode, userId } = r.data
            if (retCode === '0') {
              console.log(retMsg)
              console.log(userId)
              this.$router.push({
                path: '/email',
                query: {
                  userId: userId
                }
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
.regist {
  width: 1100px;
  margin: 10px auto;
  .re_header {
    overflow: hidden;
    line-height: 55px;
    height: 55px;
    margin: 35px 0px;
    background-color: #f5f7fa;
    ul {
      overflow: hidden;
      li {
        float: left;
        width: 280px;
        padding-left: 80px;
        color: #c1c5cd;
        .cls-or {
          display: inline-block;
          height: 12px;
          width: 12px;
          border-radius: 50%;
          box-shadow: 0 0 0 1px #c0c4cc;
        }
        .left-row {
          margin-right: 10px;
        }
        .el-icon-arrow-right {
          float: right;
          line-height: 55px;
        }
      }
      .active {
        color: rgb(28, 203, 150);
        font-weight: 600;
      }
    }
  }
  .userForm {
    width: 500px;
    margin: 10px auto;
    height: 507px;
    .vcode {
      width: 35%;
    }
    .img-code {
      width: 100px;
      margin-left: 15px;
      cursor: pointer;
      vertical-align: bottom;
    }
    .btn-reg {
      width: 60%;
      border: none;
      background-color: rgb(28, 203, 150);
    }
    .btn-reg:hover {
      background-color: rgb(28, 203, 150);
    }
    .btn-reg:focus {
      background-color: rgb(28, 203, 150);
    }
    .checkcode {
      margin-left: 15px;
      font-size: 12px;
      color: #6da2d3;
    }
    .el-form-item__content {
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/regist.vue